import React from 'react'
import FormRule from './FormRule'
import '../../styles/index.scss'
import {Link} from 'react-router-dom'
import UpdateRuleContainer from './UpdateRuleContainer'

export default UpdateRuleContainer